import styled from 'styled-components';

import { ScrollbarWrapper } from 'components/horizontal-scroller/horizontal-scroller.styled';
import {
  CardContainer,
  Container,
  LeftButtonWrapper,
  LeftCarouselButton,
  RightButtonWrapper,
  RightCarouselButton,
} from 'components/responsive-carousel/responsive-carousel.styled';

export * from './styled.default';

export const Wrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  ${Styles.desktop} {
    padding: 2.5rem 0;
  }

  ${Container} {
    margin: 0 auto;
    max-width: 770px;
  }

  ${CardContainer} {
    margin: 0;
  }

  ${RightCarouselButton},
  ${LeftCarouselButton} {
    background: ${Styles.color.white};
    color: ${Styles.color.black};
    padding-inline-start: 12px;
    border: 1px solid ${Styles.color.primary};
    > div > svg {
      fill: black;
    }
  }

  ${LeftButtonWrapper} {
    inset-inline-start: -25px;

    ${Styles.desktopLarge} {
      inset-inline-start: -55px;
    }
  }

  ${RightButtonWrapper} {
    inset-inline-end: -25px;

    ${Styles.desktopLarge} {
      inset-inline-end: -55px;
    }
  }

  ${ScrollbarWrapper} {
    display: none;
  }
`;

export const CarouselItem = styled.div<{ backgroundColor: string }>`
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: 20px;
  border: 1px solid ${Styles.color.grey.five};
  border-radius: 12px;

  ${Styles.desktop} {
    border: none;
  }
`;

export const ItemName = styled.span<{ color: string }>`
  color: ${({ color }) => color};
  font-weight: bold;
  font-size: 1rem;
  ${Styles.desktop} {
    font-size: 1.125rem;
  }
`;

export const CarouselWrapper = styled.div`
  border-block-end: 10px solid ${Styles.color.grey.five};
`;
